import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { FormComponent } from './form.component';
import { MatIconModule } from '@angular/material/icon';
import { FormFieldRendererModule } from './form-field-renderer/form-field-renderer.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { RadioFieldComponent } from './fields/radio-field/radio-field.component';
import {MatRadioModule} from "@angular/material/radio";

@NgModule({
    providers: [provideNgxMask()],
  declarations: [
    FormComponent,
  ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatIconModule,
        NgxMaskDirective,
        NgxMaskPipe,
        FormFieldRendererModule,
        MatRadioModule
    ],
    exports: [
        FormComponent,
    ],

})
export class FormModule { }
